import React from "react"

import { SHOW_CONFIRM_ADVANCE_YEAR_QUERY } from "~/components/pages/ProfilePage/utils"
import { Color } from "~/consts/style-mixins"
import { internalLink } from "~/services/helper"

import FlowMessage from "./_FlowMessage"

const HREF = internalLink("/profile", {
  query: { [SHOW_CONFIRM_ADVANCE_YEAR_QUERY]: "true" },
})

export const FlowMessageForConfirmGraduatesIn: React.VFC = () => {
  // const isMobile = useMobileMedia()

  return (
    <FlowMessage href={HREF} bgColor={Color.Attention}>
      4月1日に学年の自動繰り上げを実施しました。
      {/* {isMobile && <br />} */}
      4月からの新学年が合っているか確認しましょう
    </FlowMessage>
  )
}
